/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：af2z
 */

"use strict"

/* harmony export (binding) */
export { en_US }
var en_US = {
  "work/project_title": "My Project"
}

/***/
